export class Grid {
	hexagonWidth = 10;

	constructor(parameters = {}) {
		Object.assign(this, parameters);
		this.hexagon = new Hexagon({ width: this.hexagonWidth });
	}

	pointToHex(x, y) {
		var q = (2 / 3) * (x / this.hexagon.edge);
		var r =
			(Math.sqrt(3) * y) / (3 * this.hexagon.edge) -
			x / (3 * this.hexagon.edge);
		const hex = hexRound(new Hexagon(q, r));
		return {
			x: hex.x,
			y: hex.y,
		};
	}

	hexToPoint(q, r) {
		var x = ((this.hexagon.edge * 3) / 2) * q;
		var y = this.hexagon.edge * Math.sqrt(3) * (r + q / 2);
		return {
			x: parseFloat(x),
			y: parseFloat(y),
		};
	}
}

export function hexDistance(a, b) {
	return (
		(Math.abs(a.x - b.x) +
			Math.abs(a.x + a.y - b.x - b.y) +
			Math.abs(a.y - b.y)) /
		2
	);
}

export function cubeToHex(h) {
	var x = h.x;
	var y = h.z;
	return new Hexagon(x, y);
}

export function cubeRound(h) {
	let rx = Math.round(h.x);
	let ry = Math.round(h.y);
	let rz = Math.round(h.z);

	const x_diff = Math.abs(rx - h.x);
	const y_diff = Math.abs(ry - h.y);
	const z_diff = Math.abs(rz - h.z);

	if (x_diff > y_diff && x_diff > z_diff) {
		rx = -ry - rz;
	} else if (y_diff > z_diff) {
		ry = -rx - rz;
	} else {
		rz = -rx - ry;
	}

	return new Cube(rx, ry, rz);
}

export function hexRound(h) {
	return cubeToHex(cubeRound(hexToCube(h)));
}

export function hexToCube(h) {
	var x = h.x;
	var z = h.y;
	var y = -h.x - h.y;
	return new Cube(x, y, z);
}

export function getNeighbors(hexagon) {
	const neighbors = [];
	for (var i = 0; i < 6; i++) {
		neighbors.push(getNeighbor(hexagon, i));
	}
	return neighbors;
}

export function getNeighbor(hexagon, direction) {
	const directions = [
		{ x: 1, y: 0 },
		{ x: 1, y: -1 },
		{ x: 0, y: -1 },
		{ x: -1, y: 0 },
		{ x: -1, y: 1 },
		{ x: 0, y: 1 },
	];
	const dir = directions[direction];
	return {
		x: hexagon.x + dir.x,
		y: hexagon.y + dir.y,
	};
}

export function getDirection(x1, y1, x2, y2) {
	const x = x2 - x1;
	const y = y2 - y1;
	if (x == 1 && y == 0) {
		return 0;
	}
	if (x == 1 && y == -1) {
		return 1;
	}
	if (x == 0 && y == -1) {
		return 2;
	}
	if (x == -1 && y == 0) {
		return 3;
	}
	if (x == -1 && y == 1) {
		return 4;
	}
	if (x == 0 && y == 1) {
		return 5;
	}
}

export function heuristic(a, b) {
	return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
}

export function findPath(start, end) {
	var frontier = [start];
	var came_from = {};
	came_from[start.x + ':' + start.y] = 'START';

	while (frontier.length > 0) {
		const current = frontier.shift();
		//console.log(current);
		if (current.x == end.x && current.y == end.y) {
			//console.log('REACHED END '+current.x+':'+current.r);
			var prev = came_from[current.x + ':' + current.y];
			var path = [current, prev];
			while (true) {
				if (came_from[prev.x + ':' + prev.y]) {
					prev = came_from[prev.x + ':' + prev.y];
					if (prev == 'START') {
						break;
					} else {
						path.push(prev);
					}
				} else {
					break;
				}
			}
			return path.reverse();
		}
		const neighbors = getNeighbors(current);
		//console.log(neighbors);
		for (var i = 0; i < neighbors.length; i++) {
			const next = neighbors[i];
			//console.log(next);
			if (came_from[next.x + ':' + next.y] === undefined) {
				frontier.push(next);
				came_from[next.x + ':' + next.y] = current;
			}
		}
	}

	return false;
}

export function walk(p0, p1) {
	let dx = p1.x - p0.x,
		dy = p1.y - p0.y;
	let nx = Math.abs(dx),
		ny = Math.abs(dy);
	let sign_x = dx > 0 ? 1 : -1,
		sign_y = dy > 0 ? 1 : -1;

	let p = new Point(p0.x, p0.y);
	let points = [new Point(p.x, p.y)];
	for (let ix = 0, iy = 0; ix < nx || iy < ny;) {
		if ((0.5 + ix) / nx < (0.5 + iy) / ny) {
			// next step is horizontal
			p.x += sign_x;
			ix++;
		} else {
			// next step is vertical
			p.y += sign_y;
			iy++;
		}
		points.push(new Point(p.x, p.y));
	}
	return points;
}

export class Hexagon {
	x = 0;
	y = 0;
	width = 10;

	constructor(parameters = {}, y) {
		if (typeof parameters == 'number' && typeof y == 'number') {
			this.x = parameters;
			this.y = y;
		}
		if (typeof parameters == 'object') {
			Object.assign(this, parameters);
		}
		this.edge = this.width / 2;
		// --> width! this.dimension = (this.edge*2);
		this.halfEdge = this.edge / 2;
		this.height = this.edge * Math.sqrt(3);
		this.halfHeight = this.height / 2;
	}

	corners() {
		return [
			new Point(this.edge, 0),
			new Point(this.halfEdge, this.halfHeight),
			new Point(-this.halfEdge, this.halfHeight),
			new Point(-this.edge, 0),
			new Point(-this.halfEdge, -this.halfHeight),
			new Point(this.halfEdge, -this.halfHeight),
		];
	}

	distance(b) {
		return hexDistance(this, b);
	}

	toPoint() {
		return hexToPoint(this);
	}
}

export class Point {
	x = 0;
	y = 0;

	constructor(mixed, y = 0) {
		if (typeof mixed == 'number') {
			this.x = mixed;
		}
		this.y = y;
		if (typeof mixed == 'object') {
			Object.assign(this, parameters);
		}
	}

	toHex() {
		return pointToHex(this);
	}
}

export class Cube {
	x = 0;
	y = 0;
	z = 0;

	constructor(mixed, y = 0, z = 0) {
		if (typeof mixed == 'number') {
			this.x = mixed;
		}
		this.y = y;
		this.z = z;
		if (typeof mixed == 'object') {
			Object.assign(this, parameters);
		}
	}
}

export class TileSet {
	constructor(tiles = []) {
		this.tiles = tiles;
	}

	contains(tile) {
		for (let i = 0; i < this.tiles.length; i++) {
			if (this.tiles[i].x == tile.x && this.tiles[i].y == tile.y) {
				return true;
			}
		}
		return false;
	}

	add(tile) {
		this.tiles.push(tile);
	}
}
